import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import jQuery from 'jquery'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { sha256 } from 'js-sha256'
import 'animate.css'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(jQuery)
app.use(VueAxios, axios)

window.$ = window.jQuery = jQuery
import '@/utils/jqueryPassiveEvents'
let fecha = new Date()
app.config.globalProperties.$token = btoa(
  'thefactoryhka:' +
    sha256(
      'thefactoryhka:' +
        fecha.getFullYear() +
        ('0' + (fecha.getMonth() + 1)).slice(-2) +
        '9H6mXy0fmXl7',
    ),
)
app.config.globalProperties.$country = 've'
app.config.globalProperties.$imagePath =
  'https://thefactoryhka.com/tfhkaBancoImagenesSitesNew/public/'
app.config.globalProperties.$url = 'https://thefactoryhka.com/ve'
app.config.globalProperties.$api = '/ve-website-rest/api'
app.provide('icons', icons)
app.component('CIcon', CIcon)

app.mount('#app')
